/**
 * Privacy utility functions
 */

/**
 * Mask user name for privacy protection
 * @param name - User's full name
 * @returns Masked name - always "X**" format (first character + **)
 *
 * Rules (익명성 보장 - 이름 길이를 알 수 없게):
 * - 1 character (강): "강**"
 * - 2 characters (김강): "김**"
 * - 3 characters (김상우): "김**"
 * - 4 characters (제갈민지): "제**"
 * - 모든 이름이 동일한 X** 형식으로 표시되어 원래 이름 길이 추측 불가
 */
export function maskName(name: string): string {
  // Handle empty or invalid input
  if (!name || typeof name !== 'string') {
    return '익명'
  }

  // 첫 글자 + ** (모든 이름 동일 형식)
  return name[0] + '**'
}

/**
 * Format relative time from timestamp
 * @param timestamp - ISO timestamp string
 * @returns Formatted relative time string in Korean
 */
export function formatRelativeTime(timestamp: string): string {
  const now = new Date()
  const date = new Date(timestamp)
  const diff = now.getTime() - date.getTime()
  const minutes = Math.floor(diff / 60000)
  const hours = Math.floor(diff / 3600000)
  const days = Math.floor(diff / 86400000)

  if (minutes < 1) return '방금 전'
  if (minutes < 60) return `${minutes}분 전`
  if (hours < 24) return `${hours}시간 전`
  if (days < 7) return `${days}일 전`
  return date.toLocaleDateString('ko-KR')
}
